import { execute } from '@/api/execute'
import { GET } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'report/load'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  }
}
